import "./employeeDashboard.css";
import { Responsive, WidthProvider } from 'react-grid-layout';
import { useEmpployeeDashboard } from '../../../Hooks/Features/employeeDashboard/useEmpployeeDashboard';

const ResponsiveGridLayout = WidthProvider(Responsive);

const Dashboard = ({isLeadDashboard}) => {
    const { responsiveProps, layouts, widgets } = useEmpployeeDashboard({isLeadDashboard})

    return (
        <div className='employee-dashboard'>
            {layouts.lg && (
                <ResponsiveGridLayout {...responsiveProps}>
                    {widgets.map((item) => (
                        <div key={item.name} className={`overview-individual-widget ${ item?.hideCard ? "" : "card-container"}`}>
                            {item.compo}
                        </div>
                    ))}
                </ResponsiveGridLayout>
            )}
        </div>
    );
}

export default Dashboard;
